module.exports = __webpack_public_path__ + "static/media/link.6fe028b2.svg";